import styled from 'styled-components';
import { Button, DrawerContent, Text } from '@grupoboticario/flora-react';

export const StyledDrawerContent = styled(DrawerContent)`
  width: 532px;
  padding: 16px 32px;

  header + div {
    padding: 24px;
    overflow: auto;
    height: 100%;
  }

  footer {
    border-top: 1px solid #ccc;
    padding-top: 24px;
  }
`;

export const FilterButton = styled(Button)`
  display: flex;
  width: 115px;

  span {
    display: flex;
    align-items: center;

    height: 24px;

    sup {
      align-self: flex-start;
      margin-left: 4px;
    }
  }

  svg {
    path {
      fill: ${({ theme }) => theme.colors.actionConvertionStatic};
    }
  }

  &:hover {
    svg {
      path {
        fill: white;
      }
    }
  }
`;

export const ClearFilterButton = styled(Text)`
  cursor: pointer;
  color: #384eca;
`;

export const CalendarRef = styled.div`
  display: flex;
  width: 100%;
`;

export const CalendarInput = styled.div`
  width: 100%;
  height: 48px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.textLight};
  border-radius: 4px;
  padding: 6px 11px;
  display: flex;
  align-items: center;
  margin-top: 12px;
  & span {
    display: block;
    width: 100%;
    text-align: left;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text};
  }
  & input {
    width: 100%;
    text-align: left;
    border: 0;
    background-color: #fff;
    cursor: pointer;
    font-size: 12px;
    z-index: -1;
  }
`;

export const CalendarIcon = styled.div`
  width: 15px;
  height: 17px;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 9H6V11H4V9ZM18 4V18C18 19.1 17.1 20 16 20H2C0.89 20 0 19.1 0 18L0.00999999 4C0.00999999 2.9 0.89 2 2 2H3V0H5V2H13V0H15V2H16C17.1 2 18 2.9 18 4ZM2 6H16V4H2V6ZM16 18V8H2V18H16ZM12 11H14V9H12V11ZM8 11H10V9H8V11Z' fill='%237871D1'/%3E%3C/svg%3E");
`;

export const CalendarWrap = styled.div`
  transition: all 200ms linear 0s;
  display: flex;
  border-radius: 4px;
  position: absolute;
  z-index: 10;
  box-shadow: rgba(0, 0, 0, 0.32) 0px 4px 16px 0px;

  .react-calendar {
    width: 338px;
    max-width: 100%;
    background: white;
    border: 1px solid ${({ theme }) => theme.colors.textLight};
    border-radius: 4px;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.125em;
  }
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    box-sizing: border-box;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    display: flex;
    height: 44px;
    margin-bottom: 1em;
  }
  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: ${({ theme }) => theme.colors.background};
  }
  .react-calendar__navigation button[disabled] {
    background-color: ${({ theme }) => theme.colors.background};
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.75em;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    font-weight: bold;
    padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
  }
  .react-calendar__month-view__days__day--weekend {
    color: ${({ theme }) => theme.colors.main};
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    color: ${({ theme }) => theme.colors.text};
  }
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }
  .react-calendar__tile {
    max-width: 100%;
    text-align: center;
    padding: 0.75em 0.5em;
    background: none;
  }
  .react-calendar__tile:disabled {
    background-color: ${({ theme }) => theme.colors.background};
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: ${({ theme }) => theme.colors.background};
  }
  .react-calendar__tile--now {
    background: ${({ theme }) => theme.colors.line};
  }
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: ${({ theme }) => theme.colors.line};
  }
  .react-calendar__tile--hasActive {
    background: ${({ theme }) => theme.colors.main};
    color: #fff;
  }
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: ${({ theme }) => theme.colors.main};
  }
  .react-calendar__tile--active {
    background: ${({ theme }) => theme.colors.mainDark};
    color: white;
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: ${({ theme }) => theme.colors.main};
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: ${({ theme }) => theme.colors.background};
  }
`;
